import { type Language, SUPPORTED_LANGUAGES } from '@inflearn/i18n-tools';

export const HAS_GUIDE_LANG: Language[] = [
  SUPPORTED_LANGUAGES.ko,
  SUPPORTED_LANGUAGES.en,
  SUPPORTED_LANGUAGES.ja,
];
